import {  ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GS1LoadingService } from "@gs1france/gs1-components-library";
import { LabelValue } from "../../models/liste.model";
import { FormulaireDonneePersoService } from "../../services/formulaireDonneePerso.service";
import { StorageService } from "../../services/storage.service";
import { DocumentService } from "../../services/document.service";
import { ContactTopic, InfoPerso } from "../../models/InfoPerso.model";
import { Subscription } from "rxjs";
import { environment } from "environments/environment"; 
import { COUNTRIES } from "../../../../config/countries";
import { SmartPushService } from "../../../core/services/smartPush.service";
import { OAuthService } from "angular-oauth2-oidc";


@Component({
    selector: 'formulaire-perso',
    templateUrl: './formulaire-perso.component.html',
    styleUrls: ['./formulaire-perso.component.scss'],
})
export class FormulairePerso implements OnInit, OnDestroy {
    /**
     * If this value is set, then we are on the cgu process, otherwise its the modify process
     */
     idCompany: string;
    sendingForm = false;
    form: UntypedFormGroup;
    listsJobs: LabelValue[] = [];
    countriesList = COUNTRIES;
    infoPerso: InfoPerso;
    subs: Subscription[] = [];
    changePasswordUrl: string = environment.SSO.stsServer + '/Manage/ChangePassword';
    gender = {
        "mme" : environment.genderValues.filter((gender: any) => gender.label === 'Madame')[0],
        "mr": environment.genderValues.filter((gender: any) => gender.label === 'Monsieur')[0]
    };
    allSubs: ContactTopic[] = [];
    selectedSubs : ContactTopic[] = [];
    constructor(
        private _loaderService: GS1LoadingService,
        private _formulaireDonneePersoService: FormulaireDonneePersoService,
        private _documentService: DocumentService,
        private _storageService: StorageService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private smartPushService: SmartPushService,
        private cdRef:ChangeDetectorRef,
        private oauthService: OAuthService
    ) {}
    ngOnInit(): void {
        this._loaderService.startLoading('inscription');
        this.idCompany = this.activatedRoute.snapshot.params['idCompany'];
        this.loadData();
        this.smartPushService.smartPushUpdate( ['espace-client-mon-profil-4554']);
        
    }

    ngAfterViewChecked()
    {
    this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        for(const sub of this.subs) {
            sub.unsubscribe();
        }
    }

    async loadData() {
        try {
            await this._storageService.retrieveStaticLists();
            [this.listsJobs, this.infoPerso, this.allSubs] =  await Promise.all([
                this._storageService.getListLabelValue("Job"), this._storageService.getUser(),this._formulaireDonneePersoService.getTopics()
            ]);
            if(this.infoPerso.topics && this.infoPerso.topics.length > 0) {
                this.fillSubs(this.infoPerso.topics);
            }
            if (this.idCompany) {
                this.generateForm();
            }
        } catch (err) {
            console.error(err)
        } finally {
            this._loaderService.stopLoading('inscription');
        }
    }

    fillSubs(preferedSubs : ContactTopic[]) {
        this.allSubs.forEach(x =>  {
            x.status = preferedSubs.find(y => y.topicId.toLocaleLowerCase() == x.topicId.toLowerCase()).status;
        });
        if(this.allSubs.find(x => x.label.toLocaleLowerCase() == 'actualités gs1 france')) {
            this.allSubs.find(x => x.label.toLocaleLowerCase() == 'actualités gs1 france').tooltip = 'Notre newsletter mensuelle et/ou sectorielle.';
        }
        if(this.allSubs.find(x => x.label.toLocaleLowerCase() == 'informations et actualités standardisation')) {
            this.allSubs.find(x => x.label.toLocaleLowerCase() == 'informations et actualités standardisation').tooltip = 'Evolutions de nos standards et événements relatifs à ce sujet.';
        }
        if(this.allSubs.find(x => x.label.toLocaleLowerCase() == 'evènements et webinaires')) {
            this.allSubs.find(x => x.label.toLocaleLowerCase() == 'evènements et webinaires').tooltip = 'Invitations pour participer à des événements ou des webinaires.';
        }
        if(this.allSubs.find(x => x.label.toLocaleLowerCase() == 'services et offres commerciales')) {
            this.allSubs.find(x => x.label.toLocaleLowerCase() == 'services et offres commerciales').tooltip = 'Dernières offres de formation, conseil…';
        }
        if(this.allSubs.find(x => x.label.toLocaleLowerCase() == 'enquêtes et études')) {
            this.allSubs.find(x => x.label.toLocaleLowerCase() == 'enquêtes et études').tooltip = 'Enquêtes de satisfaction ou études pour nous permettre d’améliorer nos services.';
        }
        this.allSubs.sort(function(a, b){
            if(a.label < b.label) { return -1; }
            if(a.label > b.label) { return 1; }
            return 0;
        })

        this.selectedSubs = this.allSubs;
    }
    getLabel(list: LabelValue[], value: string) {
        return list.filter(listItem => listItem.value === value)[0]?.label;
    }

    getLabelPays() {
        return this.countriesList.filter((pays: any) => pays.alpha2Code === this.infoPerso.pays)[0].name;
    }

    generateForm() {
        this.form = this.fb.group({
            email: [{value : this.infoPerso.email, disabled: true}, Validators.required],
            roles: [{value : this.infoPerso.roles, disabled: true}, Validators.required],
            genre: [this.infoPerso.genre, Validators.required],
            nom: [this.infoPerso.nom, Validators.required],
            prenom: [this.infoPerso.prenom, Validators.required],
            telPrincipal: [this.infoPerso.telPrincipal, Validators.required],
            telSecondaire: [this.infoPerso.telSecondaire, null],
            adresse: [this.infoPerso.adresse, Validators.required],
            complementAdresse: [this.infoPerso.complementAdresse, null],
            codePostal: [this.infoPerso.codePostal, Validators.required],
            ville: [this.infoPerso.ville, Validators.required],
            pays: [this.infoPerso.pays || 'FR', Validators.required],
            jobId: [this.infoPerso.jobId, Validators.required],
            cguAcceptation: [this.infoPerso.cguAcceptation === true ? true : null, Validators.requiredTrue],
            dateAcceptation: [this.infoPerso.dateAcceptation, null],
            subscriptions: this.fb.array(this.selectedSubs.map(x => this.fb.control(x.status))),
            receiveAllSubs: [false],
            receiveNoneSubs: [false],

        });
        this.subs.push(this.form.get('cguAcceptation').valueChanges.subscribe((value) => {
            if (value === true) {
                this.form.get('dateAcceptation').setValue(new Date().toDateString());
            } else {
                this.form.get('dateAcceptation').setValue(null);
            }
            this.form.get('dateAcceptation').updateValueAndValidity();
            this.form.updateValueAndValidity();
        }));
        this.forceUpperCase('nom', true);
        this.forceUpperCase('prenom', false);
        this.form.controls['receiveAllSubs'].setValue(this.form.value.subscriptions.filter((x: boolean) => x == false).length == 0);
        this.form.controls['receiveNoneSubs'].setValue(this.form.value.subscriptions.filter((x: boolean) => x == true).length == 0);

    }
    get subscriptionsForm(){
        return this.form.get('subscriptions') as FormArray
     }

    cancelEdit(){
        for(const sub of this.subs) {
            sub.unsubscribe();
        }
        this.form = null;
        //idCompany only has value when user is redirected after connection
         if(this.idCompany) {
            this._storageService.clearStorage();
            this.oauthService.logOut();
         }
    }

    async clickCGU($event: any) {
        if ($event.target && $event.target.tagName && $event.target.tagName.toLowerCase() === 'a') {
            $event.stopPropagation();
            $event.preventDefault();
            try {
                let doc = await this._documentService.getCGU();
                await this._documentService.DownloadDocument(doc.idDoc);
            }
            catch (error) {
                console.error(error);
            }
        }
    }

    async updateContact() {
        if (this.form.valid) {
            //this.sendingForm = true;
            Object.assign(this.infoPerso, this.form.value);
            this.selectedSubs.map((x,i) => x.status = this.subscriptionsForm.value[i]);
            this.infoPerso.topics = this.selectedSubs;
            //this.form.disable();
            this._loaderService.startLoading('contact');
            try {
                await this._formulaireDonneePersoService.UpdateInfosPerso(this.infoPerso);
                this._storageService.updateUserWithName(this.infoPerso.prenom , this.infoPerso.nom);
                this._storageService.setUser(this.infoPerso);
                if(this._storageService.isRedirected) {
                    this._storageService.isRedirected = false;
                    this.router.navigate(["/hub"]);
                }
                 this.form = null;
            }finally{
                this._loaderService.stopLoading('contact');
            }
            
        }
    }


    toggleReceiveAll() {
        this.subscriptionsForm.controls.forEach((control,index )=> {
            control.setValue(true);
        });
        this.form.controls['receiveNoneSubs'].setValue(false);
    }

    toggleReceiveNone() {
        this.subscriptionsForm.controls.forEach((control,index )=> {
            control.setValue(false);
        });
        this.form.controls['receiveAllSubs'].setValue(false);
    }

    selectSub() {
        this.form.controls['receiveAllSubs'].setValue(this.form.value.subscriptions.filter((x: boolean) => x == false).length == 0);
        this.form.controls['receiveNoneSubs'].setValue(this.form.value.subscriptions.filter((x: boolean) => x == true).length == 0);
    }

    //#ToDo: delete
    async renewGS1Token(andNavigate?: boolean) {
        const idCompany = this.idCompany || this._storageService.getSession()['idCompany'];
        try {
            if (andNavigate === true) {
                const prevStateStored = localStorage.getItem("gs1-ecli-previous-state");
                const standardStateStored = localStorage.getItem("gs1-ecli-standard-state");
                if (standardStateStored) {
                    localStorage.removeItem("gs1-ecli-standard-state");

                }
                const routeStateStored = localStorage.getItem("gs1-ecli-route-state");
                if (routeStateStored) {
                    localStorage.removeItem("gs1-ecli-route-state");

                }
                if (prevStateStored) {
                    localStorage.removeItem("gs1-ecli-previous-state");
                    const prevState = JSON.parse(prevStateStored);
                    this.router.navigateByUrl(prevState.url);
                } else {
                    this.router.navigate(["/hub"]);
                }
            } else 
                this.form = null;
        } catch(error) {
            if (andNavigate)
                this.router.navigate(["/unauthorizedContact/" + error]);
            else 
                this.sendingForm = false;
        }
    }

    forceUpperCase(formControlName: string, forceAll: boolean) {
        this.subs.push(this.form.get(formControlName).statusChanges.subscribe(() => {
            if (!this.form.get(formControlName).value) {
              return;
            }
            if(forceAll) {
                if(this.form.get(formControlName).value === this.form.get(formControlName).value.toUpperCase())  {
                    return;
                   }
                this.form.get(formControlName).setValue(this.form.get(formControlName).value.toUpperCase());
                return;
            }
            if(this.form.get(formControlName).value[0] === this.form.get(formControlName).value[0].toUpperCase())  {
                return;
               }
            this.form.get(formControlName).setValue(this.form.get(formControlName).value.charAt(0).toUpperCase() + this.form.get(formControlName).value.slice(1));
             
          }));
    }

}